<template>
  <div class="data" :key="index">
    <!-- 名稱 -->
    <!-- Actions -->
    <div class='data-actions'>
    </div>
    <div class="data-info-wrapper">
      <!-- 上半部 -->
      <div class="data-info">
        <div class='campaign-basic-info'>
          <div class="campaign-name">{{dataRecord.basic_info.qp_info_name}}</div>
          <div class="campaign-period">{{ dataRecord.basic_info.days }}</div>
          <div v-if='showDirect'><div class="direct-campaign-type">指定購買</div></div>
          <div v-else>
            <div
              class='speed-campaign-type'
              :class="selectedProductLineIconClass"
            >{{selectedProductLine}}</div>
          </div>
        </div>

        <div class="data-result">
          <!-- 廣告設定 -->
          <fieldset class="data-format-budget" v-if='showDirect'>
            <legend>廣告設定</legend>
            <table>
              <tr>
                <td class='no-wrap'>媒體</td>
                <td colspan='2'>
                  <div class='taller' v-for="(media, mediaIndex) in dataRecord.condition.medias" :key="mediaIndex">
                    {{media}}
                  </div>
                </td>
              </tr>
              <tr>
                <td class='no-wrap'>預算</td>
                <th>Mobile</th>
                <td>${{ dataRecord.sim_result.mobile.budget }}</td>
              </tr>
              <tr>
                <td></td>
                <th>Desktop</th>
                <td>${{ dataRecord.sim_result.desktop.budget }}</td>
              </tr>
            </table>
          </fieldset>
          <fieldset class="data-format-budget" v-else>
            <legend>計算目標</legend>
            <table>
              <tr>
                <td></td>
                <td>跨裝置</td>
                <td>行動</td>
                <td>桌機</td>
              </tr>
              <tr>
                <td>預算</td>
                <td>{{budgetByDevice.cross_device}}</td>
                <td>{{budgetByDevice.mobile}}</td>
                <td>{{budgetByDevice.desktop}}</td>
              </tr>
              <tr>
                <td class='no-wrap'>{{adFormatTitle}}</td>
                <td colspan='3'>
                  <div v-html="adFormatText"></div>
                </td>
              </tr>
            </table>
          </fieldset>

          <!-- 計算結果 -->
          <fieldset class="data-reach" v-if='showDirect'>
            <legend>計算結果</legend>
            <table>
              <tr>
                <th></th>
                <th>Mobile</th>
                <th>Desktop</th>
              </tr>
              <tr>
                <td class='text-right'>1+ Reach</td>
                <td>{{ dataRecord.sim_result.mobile.reach }}</td>
                <td>{{ dataRecord.sim_result.desktop.reach }}</td>
              </tr>
            </table>
          </fieldset>
          <fieldset class="data-reach" v-else>
            <legend>計算結果</legend>
            <table>
              <tr>
                <td></td>
                <td>跨裝置</td>
                <td>行動</td>
                <td>桌機</td>
              </tr>
              <tr>
                <td class='text-right'>Total UU</td>
                <td>{{ dashIfZero(dataRecord.sim_result.cross_device.total_uu) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.mobile.total_uu) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.desktop.total_uu) }}</td>
              </tr>
              <tr>
                <td class='text-right'>可觸及UU數</td>
                <td>{{ dashIfZero(dataRecord.sim_result.cross_device.reach_uu) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.mobile.reach_uu) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.desktop.reach_uu) }}</td>
              </tr>
              <tr>
                <td class='text-right'>觸及佔比</td>
                <td>{{ dashIfZero(dataRecord.sim_result.cross_device.reach) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.mobile.reach) }}</td>
                <td>{{ dashIfZero(dataRecord.sim_result.desktop.reach) }}</td>
              </tr>
            </table>
          </fieldset>
        </div>
      </div>
      <!-- 下半部 -->
      <div class='data-detail data-detail-direct' v-show='openDetail' v-if='showDirect'>
        <div class="client-agency-info">
          <div class="client">{{dataRecord.basic_info.client_name}}</div>
          <div class="agency">{{dataRecord.basic_info.agency_name}}</div>
        </div>
        <div class='flv-second'>
          <div class="head">素材秒數</div>
          <div class="detail" v-if='dataRecord.condition.flv_seconds'>
            {{ dataRecord.condition.flv_seconds.name }}
          </div>
        </div>
        <table>
          <tr>
            <th>媒體</th>
            <th>格式</th>
            <th>預算</th>
          </tr>
          <tr v-for="(budgetRecord, budgetIndex) in dataRecord.budgets" :key='budgetIndex'>
            <td>
              <span
                v-if='(budgetIndex == 0) ||
                  (
                    (budgetIndex > 0) &&
                    (budgetRecord.media !== dataRecord.budgets[budgetIndex-1].media)
                  )'>{{budgetRecord.media}}</span>
            </td>
            <td>{{budgetRecord.adFormat}}</td>
            <td>${{Math.trunc(budgetRecord.budget).toLocaleString()}}</td>
          </tr>
        </table>
      </div>
      <div class='data-detail data-detail-speed' v-show="openDetail" v-else>
        <div class="compare-table">
          <div class="compare-table-row">
            <div class="compare-table-column">
              <div class="head">廣告主</div>
              <div class="detail">{{dataRecord.basic_info.client_name}}</div>
            </div>
            <div class="compare-table-column">
              <div class="head">代理商</div>
              <div class="detail">{{dataRecord.basic_info.agency_name}}</div>
            </div>
            <div class="compare-table-column">
              <div class="head"></div>
              <div class="detail"></div>
            </div>
            <div class="compare-table-column">
              <div class="head">素材秒數</div>
              <div class="detail" v-if='flvSecondName'>
                {{flvSecondName}}
              </div>
            </div>
            <div class="compare-table-column">
              <div class="head">年齡性別</div>
              <div class="detail">{{ dataRecord.condition.demos }}</div>
            </div>
            <div class="compare-table-column" v-if="isInsider">
              <div class="head">時段選擇</div>
              <div class="detail">{{ dataRecord.condition.hours }}</div>
            </div>
            <div class="compare-table-column">
              <div class="head">興趣與特定議題選擇</div>
              <div class="detail">
                <div v-html="interestOrKeywordContent"></div>
              </div>
            </div>
            <div class="compare-table-column">
              <div class="head">媒體類型</div>
              <div class="detail">
                <div v-html="mediaDetail"></div>
              </div>
            </div>
            <div class="compare-table-column" v-if="isInsider">
              <div class="head">地區選擇 </div>
              <div class="detail" v-if="dataRecord.condition.municipalities">
                  {{ dataRecord.condition.areas }}
                  {{ dataRecord.condition.areas ? `, ${dataRecord.condition.municipalities}` : compareData.condition.municipalities }}
              </div>
            </div>
            <div class="compare-table-column" v-if="isInsider">
              <div class="head">電信商選擇</div>
              <div class="detail">{{ dataRecord.condition.isps }}</div>
            </div>
            <div class="compare-table-column" v-if="isInsider">
              <div class="head">手機品牌選擇</div>
              <div class="detail">{{ dataRecord.condition.m_brands }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 開關按鈕 -->
      <div
        class="data-open-btn"
        @click="toggleDetail"
        type="info">
        <i :class="openDetail ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        <span>{{ openDetail ? '收合' : '展開' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { convertDirectDataIdToText, convertDataIdToText, toLocaleString, toPercentage } from '@/utils/dataConvert'
import { PRODUCT_LINE } from '@/constant'

const productLineIconClassMap = {
  [PRODUCT_LINE.SUPER_IMPACT]: { 'icon-si': true },
  [PRODUCT_LINE.SUPER_VIEW]: { 'icon-sv': true },
  [PRODUCT_LINE.LINE_TODAY]: { 'icon-line': true }
}

export default {
  name: 'CompareUnit',
  props: ['compareData', 'index', 'type'],
  data () {
    return {
      PRODUCT_LINE,
      openDetail: false,
      toLocaleString,
      toPercentage
    }
  },
  computed: {
    ...mapState({
      speed: state => state.speedCalculation2,
      direct: state => state.directCalculation
    }),
    ...mapGetters('permission', ['isInsider']),
    dataRecord () {
      if (this.showDirect) {
        return convertDirectDataIdToText(this.direct.options, [this.compareData])[0]
      } else {
        return convertDataIdToText(this.speed.options, [this.compareData])[0]
      }
    },
    // qp 3.0
    selectedProductLine () {
      return this.compareData.selectedProductLine
    },
    selectedProductLineIconClass () {
      return productLineIconClassMap[this.selectedProductLine]
    },
    // [desktop, mobile, cross_device] x [total_uu reach_uu budget reach]
    simResult () {
      return this.dataRecord.sim_result
    },
    budgetByDevice () {
      const getBudgetMap = (simResult, config = {}) => {
        const result = {}
        for (let key in simResult) {
          result[key] = config[key] || `$${simResult[key].budget}`
        }
        return result
      }

      switch (this.selectedProductLine) {
        case PRODUCT_LINE.SUPER_IMPACT:
          return getBudgetMap(this.simResult, { all: '' })
        case PRODUCT_LINE.SUPER_VIEW:
          return getBudgetMap(this.simResult, { mobile: '-', desktop: '-' })
        case PRODUCT_LINE.LINE_TODAY:
          return getBudgetMap(this.simResult, { cross_device: '-', desktop: '-' })
      }
    },
    adFormatTitle () {
      switch (this.selectedProductLine) {
        case PRODUCT_LINE.SUPER_IMPACT:
        case PRODUCT_LINE.LINE_TODAY:
          return '格式'
        case PRODUCT_LINE.SUPER_VIEW:
          return '媒體'
      }
    },
    adFormatText () {
      switch (this.selectedProductLine) {
        case PRODUCT_LINE.SUPER_IMPACT:
        case PRODUCT_LINE.LINE_TODAY:
          const groupNames = ['', '最大版面', '首屏曝光', '產品聚焦', '邀請互動']
          // ad_format: group_id id name title
          // ad_format_types: id rate
          const condition = this.compareData.selectedData.condition
          const adFormat = this.$lodash.cloneDeep(condition['ad_format'])
          const adFormatTypes = this.$lodash.cloneDeep(condition['ad_format_types'])
          const getText = (title, rate) => {
            rate *= 100
            return `${title}(${rate}%)`
          }
          let htmlContent = ''
          let currentGroupId = -1
          adFormat.forEach((data, index) => {
            // 更換 group 的時候
            if (currentGroupId !== data.group_id) {
              if (currentGroupId > -1) {
                htmlContent += '<br>'
              }
              currentGroupId = data.group_id
              // 因為目前的資料會錯, 所以用我自己的資料
              htmlContent += `${groupNames[currentGroupId]}<br>`
            }
            if (adFormat[index - 1] && adFormat[index - 1].group_id === currentGroupId) {
              htmlContent += ', '
            }
            //  因為排列順序相同, 所以 rate 用這種方式取得
            htmlContent += getText(data.title, adFormatTypes[index]['rate'])
          })
          return htmlContent

        case PRODUCT_LINE.SUPER_VIEW:
          return this.mediaDetail
      }
    },
    flvSecondName () {
      const map = {
        'SuperImpact': {
          60: '1~60秒',
          180: '61~180秒'
        },
        'SuperView': {
          30: '1~30秒',
          60: '31~60秒',
          90: '61~90秒'
        },
        'LINEToday': {
          60: '1~60秒',
          180: '61~180秒'
        }
      }
      return map[this.compareData.selectedProductLine][this.compareData.selectedData.flvSecond]
    },
    mediaDetail () {
      // NOTE: 這個時候拿不到資料
      // const listData = this.options['product_lines'][this.selectedProductLine].list
      const productId = this.compareData.selectedData.condition.product_line_id
      let result
      switch (this.selectedProductLine) {
        case PRODUCT_LINE.SUPER_IMPACT:
          result = this.dataRecord.condition.medias
          break
        case PRODUCT_LINE.SUPER_VIEW:
          // NOTE：先寫死
          const map = {
            10: '跨網影音',
            11: '新聞影視',
            12: '追劇娛樂'
          }
          result = map[productId]

          // const title = listData.filter(data => data.id === productId)[0].name.splice(0, 4)
          // result = title
          // NOTE: 目前沒辦法選媒體
          // if (productId === 10) {
          //   result += '<br>'
          // }
          break
        case PRODUCT_LINE.LINE_TODAY:
          result = 'LINE Today'
          break
      }
      return result
    },
    interestOrKeywordContent () {
      const { type } = this.compareData.selectedData.interestKeyword
      if (type === 'keyword') {
        return `- 特定議題 -<br>${this.dataRecord.condition.keywords}`
      } else {
        return `- 興趣 -<br>${this.dataRecord.condition.interests}`
      }
    },
    showDirect () {
      return this.type === 'direct'
    }
  },
  methods: {
    toggleDetail () {
      this.openDetail = !this.openDetail
    },
    /**
     * show zero if the parameter is a string for zero
     *
     * @param {string} value
     * @return {string} - return the given value or -
     * @example
     *    dashIfZero('0%')
     *    => return '-'
     *
     *    dashIfZero('122')
     *    => return '122'
     */
    dashIfZero (value) {
      return ((value === '0') || (value === '0%')) ? '-' : value
    }
  }
}
</script>
<style lang="scss" scoped>
.compare-info {
  margin-bottom: 24px;
  color: #f27474;
}
.data-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .data {
    position: relative;
    margin-bottom: 8px;
    width: 992px;

    .data-actions {
      position: relative;
      padding: 5px;
      display: flex;
    }

    .data-info-name {
      flex-grow: 1;
      .el-checkbox {
        white-space: normal;
        font-weight: normal;
        &__label {
          font-size: 16px;
          line-height: 1.4;
          font-weight: 600;
        }
      }
    }
    .data-close-btn {
      color: #4da1ff;
      font-size: 16px;
      cursor: pointer;
      margin-right: 21px;
      font-size: 14px;
      i { margin-right: 3px; }
    }
    .data-open-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      padding: 8px;
      width: 100%;
      border: none;
      background-color: #eeeeee;
      color: #444444;
      cursor: pointer;
      i {
        margin-right: 8px;
        font-size: 20px;
      }
    }
    .data-info-wrapper {
      background-color: #fff;
      box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    }
    .data-info {
      padding: 13px 23px 0;
    }
    .campaign-basic-info {
      position: relative;
      display: flex;
      align-items: center;
      .campaign-name {
        font-size: 16px;
        font-weight: 600;
        flex-grow: 1;
      }
      .campaign-period {
        font-size: 16px;
      }
      .speed-campaign-type {
        font-size: 12px;
        line-height: 1.5em;
        padding: 4px 16px 3px;
        color: #ffffff;
        border-radius: 12px;
        margin-left: 16px;
      }
      .direct-campaign-type {
        font-size: 12px;
        line-height: 1.5em;
        padding: 4px 16px 3px;
        color: #4a4a4a;
        border: solid 1px #4a4a4a;
        border-radius: 12px;
        margin-left: 16px;
      }
    }
    .data-result {
      display: flex;
      width: 100%;
      margin: 11px 0 17px;
      legend {
        font-size: 14px;
        color: #9b9b9b;
        padding: 0 5px;
      }
      table {
        // width: 100%;
        margin: 0 auto;
        th, td {
          text-align: left;
          padding: 3px 10px;
          vertical-align: top;
          &.text-right {
            text-align: right;
          }
          &.no-wrap {
            white-space: nowrap;
          }
        }
      }
    }
    .data-reach {
      flex-basis: 50%;
      flex-grow: 1;
      padding: 16px;
      border: solid 1px #c6c6c6;
      text-align: left;
      margin-left: 14px;
    }
    .data-format-budget {
      flex-basis: 50%;
      padding: 16px;
      border: solid 1px #c6c6c6;
    }
    .client-agency-info {
      padding: 11px 9px;
      font-size: 14px;
      .client {
        display: inline-block;
      }
      .agency {
        float: right;
      }
    }
    .data-detail {
      border-top: solid 1px #d8d8d8;
      margin: 22px 24px;
      .compare-table-column {
        &:nth-child(n) {
          padding: 20px 30px;
        }
        &:nth-child(3n+1) {
          padding-left: 0;
        }
        &:nth-child(3n) {
          padding-right: 0;
        }
      }
      .head {
        font-weight: 600;
        margin-bottom: 8px;
      }
      .detail {
        font-size: 14px;
        line-height: 1.5em;
      }
    }
    .data-detail-direct {
      display: flex;
      .flv-second {
        margin: 24px;
        width: 20%;
      }
      table {
        margin: 19px;
        width: 80%;
        th, td {
          text-align: left;
          padding: 5px;
        }
        th { font-size: 16px; }
        td { font-size: 14px; }
      }
    }
  }
}
.taller { margin-bottom: 3px; }
.compare {
  &-table {
    width: 100%;
    &-title {
      margin-bottom: 8px;
      font-weight: 600;
    }
    &-row {
      display: flex;
      flex-wrap: wrap;
    }
    &-column {
      padding: 4px 8px;
      min-width: 100px;
      width: 33%;
      &.head,
      .head {
        flex: 1;
        width: 100px;
        white-space: nowrap;
      }
      &.text-right {
        text-align: right;
      }
    }
    &-name {
      margin-top: 16px;
      margin-bottom: 8px;
    }
    &-buttons {
      display: flex;
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 120px);
  &-icon {
    position: relative;
    display: flex;
    .fa-plus-circle {
      position: absolute;
      top: -20px;
      left: -20px;
      color: #bee9e8;
      font-size: 80px;
    }
    .fa-vial {
      color: #bee9e8;
      font-size: 200px;
    }
  }
  &-text {
    margin-top: 36px;
    text-align: center;
    font-size: 18px;
    line-height: 1.5;
  }
}

.icon-si{
  background-color: #e1823c;
}
.icon-sv{
  background-color: #6799d2;
}
.icon-line{
  background-color: #57c62d;
}
</style>
